import { render, staticRenderFns } from "./FooterContent.vue?vue&type=template&id=dd095072"
import script from "./FooterContent.vue?vue&type=script&lang=js"
export * from "./FooterContent.vue?vue&type=script&lang=js"
import style0 from "./FooterContent.vue?vue&type=style&index=0&id=dd095072&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports